<template>
	<div class="tab-box">
		<div class="item" :class="[item.key === currentActive ? 'active' : '']" v-for="item in tabList" :key="item.key"
			@click="tabChange(item)">{{ item.name }}</div>
	</div>
	<div class="user-order-container">
		<div class="order-content">
			<div class="table-outer" v-if="currentActive === 'mdxqOrders'">
				<div class="table-head">
					<div class="table-column mdxq-name">礼品名称</div>
					<div class="table-column mdxq-address">收货人/收货地址</div>
					<div class="table-column mdxq-column">数量</div>
					<div class="table-column mdxq-column">消耗能量值</div>
				</div>
				<div class="table-body" v-if="currentTableOptions.tableList.length != 0">
					<div class="body-item" v-for="(item, index) in currentTableOptions.tableList" :key="index">
						<div class="body-head">
							<div class="head-item">订单号：<span>{{ item.id }}</span></div>
							<div class="head-item">下单时间：<span>{{ item.order_time }}</span></div>
							<div class="head-item me-text-beyond">
								交易状态：<span>{{ mdxqOrderStatusFn(item.status) }}</span>
							</div>
							<div class="head-item">发货快递：<span>{{ item.express_company }}</span></div>
							<div class="head-item">发货单号：<span>{{ item.express }}</span></div>
						</div>
						<div class="body-view">
							<div class="table-column mdxq-name">
								<div class="product-principal">{{ item.name }}</div>
							</div>
							<div class="table-column mdxq-address">
								<div class="product-principal">{{ item.recv_name }}（{{ item.recv_mobile }}）</div>
								<div class="product-sku">{{ item.address }}</div>
							</div>
							<div class="table-column mdxq-column product-num">{{ item.num || 0 }}</div>
							<div class="table-column mdxq-column product-num">{{ item.score || 0 }}</div>
						</div>
					</div>
				</div>
				<div class="empty" v-if="currentTableOptions.tableList.length == 0">暂无数据</div>
			</div>
			<div class="table-outer" v-else-if="currentActive === 'mallOrders'">
				<div class="table-head">
					<div class="table-column mdxq-name">商品名称</div>
					<div class="table-column mdxq-column">数量</div>
					<div class="table-column mdxq-column">应付金额</div>
					<div class="table-column mdxq-column">实付金额</div>
				</div>
				<div class="table-body" v-if="currentTableOptions.tableList.length != 0">
					<div class="body-item" v-for="(item, index) in currentTableOptions.tableList" :key="index">
						<div class="body-head">
							<div class="head-item">订单号：<span>{{ item.orderId }}</span></div>
							<div class="head-item">下单时间：<span>{{ item.createTime || '-' }}</span></div>
							<div class="head-item me-text-beyond">交易状态：<span>{{ mallOrderStatusFn(item.orderStatus) }}</span></div>
							<div class="head-item">发货快递：<span>{{ item.expressCompany || '-' }}</span></div>
							<div class="head-item">发货单号：<span>{{ item.express || '-' }}</span></div>
						</div>
						<div class="body-view">
							<div class="table-column mdxq-name">
								<div class="product-principal">{{ item.productName }}</div>
								<div class="product-sku" v-if="item.composition">{{ item.composition }}</div>
							</div>
							<div class="table-column mdxq-column product-num">{{ item.quantity || 0 }}</div>
							<div class="table-column mdxq-column product-num">{{ mallPriceFn(item.payableAmountCent) }}</div>
							<div class="table-column mdxq-column product-num">{{ mallPriceFn(item.paidAmountCent) }}</div>
						</div>
					</div>
				</div>
				<div class="empty" v-if="currentTableOptions.tableList.length == 0">暂无数据</div>
			</div>
			<div class="table-outer" v-else>
				<div class="table-head">
					<div class="table-column commodity-column">商品</div>
					<div class="table-column rests-column">商品标价</div>
					<div class="table-column rests-column">购买数量</div>
					<div class="table-column rests-column">商品实付价</div>
				</div>
				<div class="table-body" v-if="props.userDetail.syMemberId">
					<div class="body-item" v-for="(item, index) in currentTableOptions.tableList" :key="index">
						<div class="body-head">
							<div class="head-item">{{ channelFn(item.platCode) }}-{{ channelFn(item.platCode,
								'shopName') }}
							</div>
							<div class="head-item">订单号：<span>{{ item.orderSn }}</span></div>
							<div class="head-item">下单时间：<span>{{ disposeServerDateFn(item.addTime) }}</span></div>
							<div class="head-item">付款时间：<span>{{ disposeServerDateFn(item.payTime) }}</span></div>
							<div class="head-item">完成时间：<span>{{ disposeServerDateFn(item.endTime) }}</span></div>
							<div class="head-item me-text-beyond">
								交易状态：<span>{{ orderStatusFn(item.orderStatus) }}</span>
							</div>
						</div>
						<div class="body-view" v-for="(orderItem, orderIndex) in item.syOrderItemList"
							:key="orderIndex">
							<div class="table-column commodity-column">
								<div class="product-principal">{{ orderItem.productName }}</div>
								<div class="product-sku" v-if="orderItem.skuDetail">{{ orderItem.skuDetail }}</div>
							</div>
							<div class="table-column rests-column product-num">￥{{ orderItem.goodsPrice || 0 }}</div>
							<div class="table-column rests-column product-num">{{ orderItem.goodsNumber || 0 }}</div>
							<div class="table-column rests-column product-num">
								<span class="product-principal">￥{{ orderItem.payment || 0 }}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="empty" v-if="!props.userDetail.syMemberId">暂无数据</div>
			</div>
		</div>
		<div class="loading" v-if="loading && (props.userDetail.syMemberId || isCustomerOrderTab(currentActive))">加载中...</div>
	</div>

	<div class="footer">
		<pagination v-if="isShowPagination" v-model:current-page="currentTableOptions.currentPage"
			v-model:page-size="currentTableOptions.pageSize" :total="currentTableOptions.total" :page-sizes="[10, 20, 30, 40]"
			layout="total, sizes, prev, pager, next, jumper" :background="true" @size-change="handleSizeChange"
			@current-change="handleCurrentChange" />
	</div>
</template>

<script lang="ts" setup>
import { computed, ref, watch, watchEffect } from 'vue';
import { orderStatusFn, disposeServerDateFn, channelFn, mdxqOrderStatusFn, mallOrderStatusFn } from '../../../utils/enum'
import { queryUserOrderApi, queryUserMdxqOrderApi, queryUserMallOrderApi } from '@/utils/user';
import pagination from './pagination.vue';

const isShowPagination = ref(false)
const props = defineProps<{
	userDetail: any
}>()

// tab配置相关
const tabList: any = ref([
	{
		name: '蔓迪商城订单',
		key: 'mallOrders',
		currentPage: 1,
		pageSize: 10,
		total: 0,
		tableList: []
	},
	{
		name: '星球能量值订单',
		key: 'mdxqOrders',
		currentPage: 1,
		pageSize: 10,
		total: 0,
		tableList: []
	},
	{
		name: '电商渠道订单',
		key: 'allOrders',
		currentPage: 1,
		pageSize: 10,
		total: 0,
		tableList: []
	},
	{
		name: '近3个月订单',
		key: 'recent3MonthsOrders',
		currentPage: 1,
		pageSize: 10,
		total: 0,
		tableList: []
	}
])

// 监听tab切换，获取当前tab对应的table的数据
const currentTableOptions:any = computed(() => {
	const result = tabList.value.find((item: any) => item.key === currentActive.value)
	const hasRows = Boolean(result.tableList && result.tableList.length)
	// 商城订单按蔓迪星球 userId 查询，不要求同时存在 syMemberId。
	const canPaginate = currentActive.value === 'mallOrders'
		? Boolean(props.userDetail.id)
		: Boolean(props.userDetail.syMemberId)
	isShowPagination.value = hasRows && canPaginate
	return result;
})

const loading = ref(false)
const currentActive = ref('mallOrders');

const isCustomerOrderTab = (key: string) => key === 'mdxqOrders' || key === 'mallOrders'

// 蔓迪商城金额格式化（分 → 元）
const mallPriceFn = (cent: any) => {
	if (cent === null || cent === undefined || cent === '') return '-'
	return '￥' + (Number(cent) / 100).toFixed(2)
}

// 获取订单列表
const getOrderList = async (key: string) => {
	try {
		loading.value = true;
		console.log(currentTableOptions, "currentTableOptions");

		const pageParams: any = {
			"pageNum": currentTableOptions.value.currentPage,
			"pageSize": currentTableOptions.value.pageSize
		}
		let res: any = {}
		if (currentActive.value === 'mdxqOrders') {
			res = await queryUserMdxqOrderApi({
				...pageParams,
				syMemberId: props.userDetail.syMemberId,
				customerId: props.userDetail.id
			})
		} else if (currentActive.value === 'mallOrders') {
			res = await queryUserMallOrderApi({
				...pageParams,
				userId: props.userDetail.id
			})
		} else {
			const params = { ...pageParams, syMemberId: props.userDetail.syMemberId }
			res = await queryUserOrderApi(currentActive.value === 'recent3MonthsOrders' ? { ...params, nearly: 1 } : params)
		}

		tabList.value.map((item: any) => {
			if (item.key === key) {
				item.tableList = res?.body?.list || []
				item.total = res?.body?.count || 0

				console.log('okkoo', tabList.value);

			}
		})
	} catch (err: any) {
		console.log(err);
	} finally {
		loading.value = false;
	}
}


const handleCurrentChange = (val: number) => {
	getOrderList(currentActive.value)
}

const handleSizeChange = (val: number) => {
	getOrderList(currentActive.value)
}


// tab切换
const tabChange = async (item: any) => {
	currentActive.value = item.key
	if (!item.isLoad && props.userDetail.id && (props.userDetail.syMemberId || isCustomerOrderTab(currentActive.value))) {
		item.isLoad = true
		await getOrderList(item.key)
	}
}


const isFirstLoad = ref(true)

// 会话切换时清理上一位用户的订单，避免右侧栏短暂展示旧数据。
watch(() => props.userDetail.id, (userId, previousUserId) => {
	if (!userId || userId === previousUserId) return

	tabList.value.forEach((item: any) => {
		item.isLoad = false
		item.currentPage = 1
		item.total = 0
		item.tableList = []
	})
	isFirstLoad.value = true
}, { immediate: true })

// 监听，如果当前没有syMemberId，就不加载数据
watchEffect(() => {
	if (props.userDetail.id && (props.userDetail.syMemberId || isCustomerOrderTab(currentActive.value))) {
		if (isFirstLoad.value) {
			tabList.value.map((item: any) => {
				if (item.key === currentActive.value) {
					item.isLoad = true
				}
			})
			getOrderList(currentActive.value)
			isFirstLoad.value = false;
		}
	}
})

</script>

<style scoped lang="scss">
:not(not) {
	box-sizing: border-box;
}

// 头部tab切换
.tab-box {
	margin-top: 10px;
	display: flex;
	align-items: center;

	.item {
		padding-bottom: 15px;
		border-bottom: 2px solid #eee;
		width: 140px;
		text-align: center;
	}

	.active {
		border-bottom: 2px solid #0299b5;
	}
}

// 表格内容
.user-order-container {
	flex: 1;
	overflow-y: auto;
	position: relative;
	min-height: 100px;

	margin-top: 20px;

	.loading {
		position: sticky;
		height: 100%;
		z-index: 4;
		top: 0;
		bottom: 0;
		width: 100%;
		font-size: 14px;
		color: #999;
		background-color: rgba(255, 255, 255, 0.9);
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.order-content {}

	.empty {
		height: 340px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 14px;
		color: #999;
	}
}

// 分页
.footer {
	display: flex;
	padding: 20px 10px;
}


// 从曼迪星球那边拿过来的样式
/* 表格头部 */
.table-head {
	min-height: 45px;
	background: #FAFAFA;
	font-size: 14px;
	font-weight: bold;
	color: #66686C;
	display: flex;
}

.table-column {
	padding: 10px 15px;
	white-space: nowrap;
	// 数字应为不换行BUG
	word-break: break-all;
}

.commodity-column {
	flex: 1;
	text-align: left;
}

.rests-column {
	width: 135px;
	text-align: center;
}

.mdxq-name {
	flex: 1;
	text-align: center;
}

.mdxq-address {
	flex: 1;
	text-align: center;
}

.mdxq-column {
	width: 100px;
	text-align: center;
}

/* 表格内容 */
.table-body {
	overflow-y: auto;
}

/* 修改table-body滚动条样式 */
.table-body::-webkit-scrollbar {
	width: 4px;
	height: 4px;
}

.table-body::-webkit-scrollbar-thumb {
	background: #DCDFE6;
	border-radius: 3px;
}

.table-body::-webkit-scrollbar-track {
	background: #F5F7FA;
	border-radius: 3px;
}

.body-item {
	width: 100%;
	margin-top: 10px;
	background: #FFFFFF;
	border: 1px solid #EBEEF5;
}

.body-head {
	width: 100%;
	padding: 11px 0 5px 0;
	background: #FAFAFA;
	display: flex;
	flex-wrap: wrap;
}

.head-item {
	flex-shrink: 0;
	width: 33.33%;
	padding: 0 15px 10px 15px;
	font-size: 12px;
	color: #606266;
	text-align: left;
	// 数字应为不换行BUG
	word-break: break-all;
}

.head-item span {
	font-size: 12px;
	color: #AFB0B2;
}

.body-view:first-child {
	margin-top: 0;
}

.body-view {
	border-top: 1px solid #EBEEF5;
	background-color: #FFFFFF;
	display: flex;
}

.body-view .table-column:first-child {
	border-left: 0;
}

.body-view .table-column {
	border-left: 1px solid #EBEEF5;
	padding: 18px 15px;
}

.body-view .rests-column {
	align-content: center;
}

.product-principal {
	font-size: 12px;
	color: #0299B5;
	white-space: normal;
}

.product-num {
	font-size: 12px;
	white-space: normal;
	word-break: break-all;
}

.product-sku {
	margin-top: 6px;
	font-size: 12px;
	color: #AFB0B2;
}
</style>
